<template>
  <div class="errorMsg" :style="{width:msgwidth}" v-if="errorMsg !== ''">
    <div style="width: 15%; text-align: center; font-size: 20px; color: red;">
      <!-- Replace the SVG with your actual icon SVG -->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
        <g id="iconifyReact0">
          <g id="iconifyReact1">
            <path id="iconifyReact2" fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 14a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0Zm-1-7a1 1 0 1 1 1-1a1 1 0 0 1-1 1Z"></path>
          </g>
        </g>
      </svg>
    </div>
    <div style="width: 80%; text-align: left; overflow-wrap: break-word; color: #9B4259;">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errorMsg: {
      default:"",
      type: String,
      required: true
    },
    msgwidth: {
      default:'330px',
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
.errorMsg {
  width: 330px;
  display: flex;
  background-color: #FFE7D9;
  border-radius: 8px;
  //align-items: center;
  margin: 0 auto;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/errorMsg/errorMsg.vue